import React, { useContext, useEffect, useState } from "react";
import { fetchColorTags } from "../../api/ColorTags";
import { Select } from "antd";
import { UserContext } from "../../context/UserContext";
import { getContrastColor } from "../../components/dispatches/helpers";

const { Option } = Select;

const ColorTagSection = ({
  isEditMode = true,
  selectedColor,
  setSelectedColor,
}) => {
  const [colorOptions, setColorOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const { currentOrg } = useContext(UserContext);

  const fetchDispatchStatusColorData = async () => {
    try {
      const orgId = currentOrg.id;
      const res = await fetchColorTags(orgId);
      if (res?.data?.color_tags) {
        const modifiedData = res.data.color_tags.map((tag) => ({
          label: tag.name,
          code: tag.name.toLowerCase().replace(/\s+/g, "_"),
          color: tag.color_code,
          id: tag.id,
        }));
        setColorOptions(modifiedData || []);
      } else {
        setColorOptions([]);
      }
    } catch (error) {
      console.error("Error fetching color tags:", error);
      setColorOptions([]);
    }
  };

  const handleColorChange = (value) => {
    const selected = colorOptions.find((option) => option.code === value);
    setSelectedColor(selected);
    setSelectedValue(selected);
  };

  useEffect(() => {
    fetchDispatchStatusColorData();
  }, []);

  return (
    <>
      {isEditMode ? (
        <div className="color_tags_dropdown">
          <Select
            data-testid="color-tags-dropdown"
            onChange={handleColorChange}
            value={
              selectedValue ? selectedValue.code : selectedColor?.code || null
            }
            style={{
              backgroundColor: selectedValue
                ? selectedValue.color
                : selectedColor?.color || null,
              color: getContrastColor(
                selectedValue ? selectedValue.color : selectedColor?.color || ""
              ),
              width: 200,
              alignContent: "center",
              border: "1px solid #8897a4",
              borderRadius: "4px",
              // paddingLeft: 5,
            }}
            placeholder="Select a color"
            className="colorDropDown customSelection OptionsStyle"
          >
            <Option key="default" value={null}>
              -- Select --
            </Option>
            {colorOptions.map((tag) => (
              <Option
                key={tag.code}
                value={tag.code || "-- Select --"}
                style={{
                  backgroundColor: tag.color,
                  color: getContrastColor(tag.color),
                }}
              >
                {tag.label}
              </Option>
            ))}
          </Select>
        </div>
      ) : (
        <div>
          <div
            style={{
              backgroundColor: selectedColor?.color || null,
              color: getContrastColor(selectedColor?.color || ""),
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding: "6px",
            }}
          >
            {selectedColor?.label || "No color selected"}
          </div>
        </div>
      )}
    </>
  );
};

export default ColorTagSection;
